import React from 'react'
import './Holidays.css'

const Holidays = () => {
  return (
    <div>Holidays</div>
  )
}

export default Holidays